import IcQuestion from 'assets/images/backoffice/capital/ic-question-mark.svg';
import React from 'react';
import InfoCard from './InfoCard';
import styles from './InfoCard.css';

function FastLoanTenorInfo() {
  return (
    <InfoCard
      title="Apa itu Moka Capital Fast Loan?"
      icon={<img src={IcQuestion} className={styles.question} />}
    >
      <div className={styles['tenor-info']}>
        <p className={styles['tenor-content']}>
          <b>Moka Capital</b> bekerja sama dengan <b>PT Bank Commonwealth</b>
          &nbsp; menghadirkan produk pinjaman modal usaha dengan proses aplikasi
          yang cepat dan mudah dengan bunga yang bersaing. Pinjaman mulai Rp10
          juta hingga Rp200 juta dengan tenor hingga 3 tahun. Proses pencairan
          kurang dari 2 hari kerja.
        </p>
      </div>
    </InfoCard>
  );
}

export default FastLoanTenorInfo;
